import type { IconProps } from "@/components/Icons/index";

/** From `public/assets/images/figma/sidebar-logo.svg` — `viewBox="0 0 98 14"`. */
export const SidebarLogoIcon: React.FC<IconProps> = (props) => (
  <svg viewBox="0 0 98 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g>
      <path d="M32.367 10.5H28.7706V14H32.367V10.5Z" fill="currentColor" />
      <path
        d="M52.8183 0.338333H52.8063C52.5785 0.116666 52.2788 0 51.9552 0H37.9654C37.6418 0 37.3421 0.128333 37.1143 0.338333L35.424 1.98333C35.1963 2.205 35.0764 2.49667 35.0764 2.81167V14H38.6727V3.5H51.2599V14H54.8562V2.81167C54.8562 2.49667 54.7244 2.205 54.5086 1.98333L52.8183 0.338333Z"
        fill="currentColor"
      />
      <path
        d="M58.7043 0.338333H58.6923L57.002 1.98333C56.7743 2.205 56.6544 2.49667 56.6544 2.81167V3.5H76.4342V0H59.5554C59.2317 0 58.9321 0.128333 58.7043 0.338333Z"
        fill="currentColor"
      />
      <path
        d="M59.5434 5.26167C59.2198 5.26167 58.9201 5.39 58.6923 5.6L57.002 7.245C56.7743 7.46667 56.6544 7.75833 56.6544 8.07333V11.1883C56.6544 11.5033 56.7862 11.795 57.002 12.0167L58.6923 13.6617C58.9201 13.8833 59.2198 14 59.5434 14H76.4342V10.5H60.2387V8.75H76.4342V5.25H59.5434V5.26167Z"
        fill="currentColor"
      />
      <path
        d="M24.0834 0.338333C23.8557 0.116666 23.556 0 23.2323 0H8.28365C7.95998 0 7.66029 0.128333 7.43252 0.338333L5.74225 1.98333C5.51448 2.205 5.3946 2.49667 5.3946 2.81167V3.5H22.537V8.75H26.1333V2.81167C26.1333 2.49667 26.0015 2.205 25.7857 1.98333L24.0954 0.338333H24.0834Z"
        fill="currentColor"
      />
      <path
        d="M8.99083 10.5V5.25H5.3945V11.1883C5.3945 11.5033 5.52636 11.795 5.74214 12.0167L7.43242 13.6617C7.66018 13.8833 7.95988 14 8.28355 14H23.2443C23.568 14 23.8676 13.8717 24.0954 13.6617L25.7857 12.0167C26.0135 11.795 26.1333 11.5033 26.1333 11.1883V10.5H8.99083Z"
        fill="currentColor"
      />
      <path
        d="M0 11.1883C0 11.5033 0.131866 11.795 0.347645 12.0167L2.03792 13.6617C2.26569 13.8833 2.56538 14 2.88905 14H3.59633V5.25H0V11.1883Z"
        fill="currentColor"
      />
      <path
        d="M2.03792 0.338333L0.347645 1.98333C0.119878 2.205 0 2.49667 0 2.81167V3.5H3.59633V0H2.88905C2.56538 0 2.26569 0.128333 2.03792 0.338333Z"
        fill="currentColor"
      />
      <path
        d="M97.6524 1.98333L95.9621 0.338333H95.9501C95.7223 0.128333 95.4226 0 95.099 0H89.9083V3.5H98V2.81167C98 2.49667 97.8801 2.205 97.6524 1.98333Z"
        fill="currentColor"
      />
      <path
        d="M87.8705 0.338333C87.6428 0.116666 87.3431 0 87.0194 0H81.1334C80.8097 0 80.51 0.128333 80.2823 0.338333H80.2703L78.58 1.98333C78.3522 2.205 78.2324 2.49667 78.2324 2.81167V3.5H86.3121V14H89.9084V2.78833C89.9084 2.485 89.7766 2.205 89.5608 1.98333L87.8705 0.338333Z"
        fill="currentColor"
      />
    </g>
  </svg>
);
